if (!window.customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        threshold: 0,
      });
      this.loaded = false;
    }

    connectedCallback() {
      this.observer.observe(this);

      document.addEventListener("DOMContentLoaded", () => {
        if (!this.loaded) {
          this.loadProductsIfNotVisible();
        }
      });
    }

    async onIntersect(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting && !this.loaded) {
          this.observer.unobserve(entry.target);
          this.loaded = true;

          const query = this.buildQuery();
          if (query) {
            this.loadProducts(query);
          }
        }
      }
    }

    loadProductsIfNotVisible() {
      const rect = this.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (!isVisible && !this.loaded) {
        this.loaded = true;
        const query = this.buildQuery();
        if (query) {
          this.loadProducts(query);
        }
      }
    }

    buildQuery() {
      const items = JSON.parse(localStorage.getItem("recently-viewed") || "[]");
      const excludeId = this.getAttribute("data-product-id");
      if (excludeId) {
        const index = items.indexOf(parseInt(excludeId));
        if (index !== -1) {
          items.splice(index, 1);
        }
      }
    
      const limitedItems = items.slice(-this.productLimit).reverse();
      return limitedItems.map((id) => `id:${id}`).join(" OR ");
    }

    async loadProducts(query) {
      try {
        const response = await fetch(
          `${window.routes.root_url}search?q=${query}&resources[limit]=10&resources[type]=product`
        );
    
        const html = await response.text();
        const products = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("#search-list-id");
    
        if (products && products.hasChildNodes()) {
          const innerSection = this.querySelector(".product-grid");
          if (innerSection) {
            const productElements = Array.from(products.children);
    
            const items = JSON.parse(localStorage.getItem("recently-viewed") || "[]").slice(-this.productLimit).reverse();
            const sortedProducts = items
              .map((id) =>
                productElements.find((el) => {
                  const productId = el.querySelector("[data-product-id]")?.getAttribute("data-product-id");
                  return productId && productId === id.toString();
                })
              )
              .filter((el) => el);
    
            innerSection.innerHTML = "";
            sortedProducts.forEach((el) => innerSection.appendChild(el));
          }
        } else {
          console.warn("No products found in the response.");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    }    

    get sectionId() {
      return this.getAttribute("data-section-id");
    }

    get productLimit() {
      return parseInt(this.getAttribute("data-products-limit")) || 4;
    }
  }

  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}